<p-dialog
  *ngIf="showSelectPlanDialog"
  [visible]="showSelectPlanDialog"
  (visibleChange)="onFlag('showSelectPlanDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [showHeader]="false"
  class="dialog select-plan-dialog"
  [style]="{ 'max-width': isMobile ? '90%' : '80%', overflow: 'auto' }"
  appendTo="body"
  styleClass="select-pitch-type-dialog">
  <app-pricing-card-type-select
    *ngIf="showSelectPlanDialog && selectPlanBusinessId !== null"
    [businessId]="selectPlanBusinessId"
    (paymentSuccess)="
      onSelectPlanPaymentSuccess($event)
    "></app-pricing-card-type-select>
</p-dialog>
